import { render, staticRenderFns } from "./FansAll.vue?vue&type=template&id=24c3dcfd&scoped=true&"
import script from "./FansAll.vue?vue&type=script&lang=js&"
export * from "./FansAll.vue?vue&type=script&lang=js&"
import style0 from "./FansAll.vue?vue&type=style&index=0&id=24c3dcfd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c3dcfd",
  null
  
)

export default component.exports